import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './skincare/Header';
import Footer from './skincare/Footer';
import Home from './skincare/Home';
import Ritual from './skincare/Ritual';
import Atelier from './skincare/Atelier';
import Visit from './skincare/Visit';

export default function SkincareTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F2EBE0]" data-testid="skin-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`skin-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'ritual' && <Ritual setPage={setPage} />}
          {page === 'atelier' && <Atelier setPage={setPage} />}
          {page === 'visit' && <Visit setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
